(function () {
    /**
     * Enhanced Search
     * 
     * @module enhancedSearch
     */

    /**
     * Check if the enhanced search class is present on the page
     */
     function isEnhancedSearchPage() {
        return document.querySelector('.enhanced-search') !== null;
    }

    if (isEnhancedSearchPage()) {

        var enhancedSearch = {};
        var windowWidth = window.innerWidth;

        /**
         * Initialise the Enhanced Search listeners for keyboard navigation
         * 
         * @memberof module:enhancedSearch
         */
        enhancedSearch.init = function() { 
            var queryParam = new URLSearchParams(window.location.search).get('query');

            if (queryParam) {
                highlightSearchTerm(queryParam);
            }

            if (document.querySelector('.qld__search__facet-list')) {
                setMobileView();
    
                window.addEventListener('resize', debounce(checkWindowResize, 100));
                
                var accordionButtons = document.querySelectorAll('.qld__search__facet-title.qld__accordion__title');
                if(accordionButtons.length > 1){
                    document.querySelector('.qld__search__facets-title-wrap .qld__search__toggle-all').classList.remove('qld__search__toggle-all--hide');
                } 
                
                var toggleButtons = document.querySelectorAll('.qld__search__facet-list .qld__search__facet-button--toggle');
                if (toggleButtons) {
                    initializeFacetListToggleButtons(toggleButtons);
                }
            };
        }

        function highlightSearchTerm(queryParam) {
            var pageContent = document.querySelectorAll('[data-highlight]'); //('.qld__search__result-header a, .qld__search__result-header .qld__breadcrumbs li, .qld__search__result-summary');

            for (var i = 0; i < pageContent.length; i++) { 
                var content = pageContent[i].textContent;
                var wrappedContent = content.replace(new RegExp(queryParam, 'gi'), '<strong>$&</strong>');

                if (content !== wrappedContent) {
                    pageContent[i].innerHTML = wrappedContent;
                }
            };
        }

        function initializeFacetListToggleButtons(toggleButtons) {
            for (var i = 0; i < toggleButtons.length; i++) {
                (function(button) {
                    var facetList = button.closest('.qld__search__facet-list');
                    var listItems = facetList.querySelectorAll('li:not(.more)');
        
                    // Initially hide items beyond the 8th
                    hideAdditionalFacetListItems(listItems);
        
                    button.addEventListener('click', function() {
                        toggleFacetListItems(button, listItems);
                    });
                })(toggleButtons[i]);
            }
        }

        function hideAdditionalFacetListItems(listItems) {
            if (listItems.length > 8) {
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.add('hidden');
                }
            }
        }

        function toggleFacetListItems(button, listItems) {
            var isShowingAll = button.classList.contains('showing-all');
        
            if (isShowingAll) {
                // Currently showing all items - hide extras and update button
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.add('hidden');
                }
                button.textContent = 'Show all';
                button.classList.remove('qld__search__facet-button--hide');
                button.classList.add('qld__search__facet-button--show');
            } else {
                // Currently showing less items - show all and update button
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.remove('hidden');
                }
                button.textContent = 'Show less';
                button.classList.remove('qld__search__facet-button--show');
                button.classList.add('qld__search__facet-button--hide');
            }
            // Toggle class to reflect current state
            button.classList.toggle('showing-all');
        }

        function checkWindowResize() {
            var newWidth = window.innerWidth;

            if (windowWidth > 991 && newWidth < 992) {
                setMobileView();
            }

            windowWidth = newWidth;
        }

        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        function setMobileView() {
            const facetListItems = document.querySelectorAll('.qld__search__facet-list .qld__search__facet-title');

            for (let i = 0; i < facetListItems.length; i++) {
                facetListItems[i].classList.add('qld__search__facet-title--mobile');
            }
        }

        document.addEventListener('DOMContentLoaded', function () {
            enhancedSearch.init();
        });
    }
}());